import { Palette } from 'mm-theme-configuration/dist/interfaces';

export class PaletteManager {
  palette: Palette;

  constructor(palette: Palette) {
    this.palette = palette;
  }

  getColorByKey(key: string) {
    return this.palette.colors[key];
  }

  getFonts() {
    return this.palette.fonts;
  }

  getFontSizeMap() {
    return { ...this.palette.fontSizeMap };
  }
}
